import type { ActivityType } from '../../../../typings'

type Props = {
  activityTypes: ActivityType[]
}

export function useData(props: Props) {
  const { activityTypes } = props
  const maxActionTypes = 50
  const isAddDisabled = activityTypes.length === maxActionTypes
  const currentQuantity = activityTypes.length

  return {
    isAddDisabled,
    maxActionTypes,
    currentQuantity,
  }
}
